var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vbt-dialog',{attrs:{"title":_vm.title,"hide-submit-btn":"","width":"80%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('ir-invoices-list',{attrs:{"items":_vm.invoices,"paged":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }